import { styled, Chip, ChipProps, Box } from "@mui/material";
import React from "react";
import { ColorType } from "../../../../Core/Api/Types/color-type";
import { DbUserGroupRoleInfos } from "../../../../Core/Api/Types/db-user-group-role-infos";
import UserChip from "../UserChip/user-chip";

export interface UserGroupChipProps extends ChipProps {
  roleId?: number | null;
  roles: DbUserGroupRoleInfos[];
  onDelete?: () => void;
}

const UserGroupChip: React.FC<UserGroupChipProps> = (props) => {
  const { roleId, roles, onDelete = undefined, ...otherProps } = props;
  const [color, setColor] = React.useState<ColorType>(ColorType.Grey);
  const [roleName, setRoleName] = React.useState<string | null>(null);

  React.useEffect(() => {
    const groupRole: DbUserGroupRoleInfos | undefined = roles.find((role) => role.id === roleId);
    if (groupRole?.color && ColorType[groupRole?.color]) setColor(ColorType[groupRole?.color]);
    if (groupRole?.name) setRoleName(groupRole.name);
  }, [roleId]);

  return (
    <StyledChip
      variant="tag"
      size="large"
      onDelete={onDelete}
      label={
        <Box component="span" display="inline-flex">
          <UserChip colorType={color} sx={{ mr: 1 }} roleName={roleName} />
        </Box>
      }
      {...otherProps}
    />
  );
};

export default UserGroupChip;

const StyledChip = styled(Chip)(({ theme }) => ({
  height: 34,
  "> .MuiChip-label": {
    paddingLeft: theme.spacing(1),
  },
}));
